import EmptySearch from "./components/EmptySearch";
import NonRegistered from "./components/NonRegistered";
import Property from "@/components/Property";
import Filters from "./components/Filters";
import SortBy from "./components/SortBy";
import Tabs from "./components/Tabs";
import Questionary from "@/views/Home/components/Questionary";

import PromoSignUp from "@/components/PromoSingUp";
import Pagination from "@/components/Pagination";

import { isochrone } from "../../assets/js/isochrone";

import MapIcon from "@/assets/images/icons/map.svg?inline";
import LoadingIcon from "@/assets/images/icons/loading-white.svg?inline";

import { mapGetters } from "vuex";

import debounce from "lodash/debounce";

import {QUESTIONARY_PARSAMS} from "./gql/PropertiesQueries";

export default {
  name: "properties",

  data() {
    return {
      properties: [],
      busy: false,
      isPropertiesLoading: true,
      skipPropertiesQuery: true,
      gmapOptions: {
        maxZoom: 17,
        streetViewControl: false
      },
      searchParams: {
        address: {
          placeId: ""
        },
        page: 1,
        perPage: 20,
        sort: "score",
        sortOrder: "desc",
        marketStatus: "all",
        filters: [],

        mapFilters: {
          cluster: null,
          latitudes: [],
          longitudes: []
        },
        skipUpdateMap: false
      },
      isMapOpen: true,
      markers: [],
      circles: [],
      circleOptions: {
        fillColor: "rgba(240, 115, 0)",
        fillOpacity: 0.2,
        strokeWeight: 0
      },

      pins: [],

      polygonOptions: {
        strokeColor: "#31D895",
        strokeOpacity: 0.8,
        strokeWeight: 2,
        fillColor: "#31D895",
        fillOpacity: 0.35
      },

      isClusters: true,

      infoWindowPos: null,
      infoWinOpen: false,
      currentMidx: null,
      infoOptions: {},

      currentBounds: {},
      isShowUpdateMapBtn: false,
      isUpdateByNewViewPort: false,
      listenChanges: false,
      isShowModal: false,

      gmapZoom: 7,
      gmapCenter: {
        lat: 40.4670259605,
        lng: -86.95195126725
      },

      polygonPaths: []
    };
  },

  props: [],

  apollo: {
    properties: {
      query: QUESTIONARY_PARSAMS,
      fetchPolicy: "no-cache",
      variables() {
        return {
          address: this.searchParams.address,
          page: this.searchParams.page,
          perPage: this.searchParams.perPage,
          sort: this.searchParams.sort,
          sortOrder: this.searchParams.sortOrder,
          marketStatus: this.searchParams.marketStatus,
          filters: this.searchParams.filters,
          mapFilters: this.searchParams.mapFilters,
          skipUpdateMap: this.searchParams.skipUpdateMap
        };
      },

      skip() {
        return this.skipPropertiesQuery;
      },

      result({data}) {
        history.pushState(
          {},
          null,
          this.$route.path + 'homes' +
          '?' +
          Object.keys(this.searchParams)
            .map(key => {
              return encodeURIComponent(key) + '=' + encodeURIComponent(JSON.stringify(this.searchParams[key]))
            })
            .join('&')
        );

        let properties = data.properties;

        this.$store.commit("setProperties", {properties: properties, isPagination: this.busy});

        this.busy = false;

        if (!this.searchParams.skipUpdateMap) {
          this.collectMarkers();
        }

        this.isShowUpdateMapBtn = false;
        this.skipPropertiesQuery = true;

        if (properties.entities.length <= 20) {
          this.isPropertiesLoading = false;
          this.$refs.resultContainer.scrollTop = 0;
          window.scrollTo({top: 0, behavior: "smooth"});
        }
      }
    }
  },

  beforeRouteEnter(to, from, next) {
    next(vm => vm.setData(to.query));
  },

  computed: {
    ...mapGetters({
      currentUser: "getUser"
    }),

    isShowMap() {
      if (this.isMapOpen) {
        return true;
      } else {
        return false;
      }
    },

    propertiesData() {
      return this.$store.getters.doneProperties;
    },

    propertySizeClass() {
      let cssClass = "col-lg-6 col-md-4";

      if (!this.isShowMap) {
        cssClass = "col-lg-3 col-md-4";
      }

      return cssClass;
    },

    propertyFirstSizeClass() {
      let cssClass = "col-lg-12 col-md-12";

      if (!this.isShowMap) {
        cssClass = "col-lg-6 col-md-4";
      }
      return cssClass;
    },

    filters() {
      if (this.$store && this.$store.state.filters) {
        return this.$store.state.filters;
      }
    }
  },

  watch: {
    filters(newFilters) {
      if (newFilters) {
        newFilters.filters.forEach(f => {
          delete f.__typename;
        });

        this.searchParams.address.placeId = newFilters.address.placeId;
        this.searchParams.filters = newFilters.filters;

        this.searchParams.mapFilters = {
          cluster: null,
          latitudes: [],
          longitudes: []
        };
        this.skipPropertiesQuery = false;
        this.isPropertiesLoading = true;
      } else {
        this.skipPropertiesQuery = false;
      }
    },

    markers(markers) {
      if (markers.length > 0) {
        this.$refs.gmap.$mapPromise
          .then(map => {
            if (!this.isUpdateByNewViewPort) {
              var bounds = new google.maps.LatLngBounds();

              markers.forEach(marker => {
                bounds.extend(
                  new google.maps.LatLng(
                    marker.position.lat,
                    marker.position.lng
                  )
                );
              });
              map.fitBounds(bounds);
            } else {
              this.isUpdateByNewViewPort = false;
            }
          })
          .then(() => {
            setTimeout(() => {
              this.listenChanges = true;
            }, 3000);
          });
      }
    },

    currentUser(newV) {
      if (newV.isochroneParams != null) {
        this.$refs.gmap.$mapPromise.then(() => {
          this.cycle();
        });
      }
    }
  },

  mounted: function () {
    if (this.$mq === "md" || this.$mq === "sm" || this.$mq === "xs") {
      this.isMapOpen = false;
    }

    if (this.currentUser.isochroneParams != null) {
      this.$refs.gmap.$mapPromise.then(() => {
        this.cycle();
      });
    }
  },

  methods: {
    setData(params) {
      if (!params)
        return;
      Object.keys(params).forEach((k) => {
          this.$set(this.searchParams, k, JSON.parse(decodeURIComponent(params[k])));
        }
      );
    },

    isMaxedOffMarket() {
      return (this.searchParams.page * this.propertiesData.pagination.perPage > this.propertiesData.tabHeaders.offMarketClaimed)
      && !this.currentUser.id && this.searchParams.marketStatus === 'off_market' && this.propertiesData.tabHeaders.offMarket >= 1;
    },

    isNoOffMarketClaimed() {
      return this.propertiesData.tabHeaders.offMarketClaimed == 0 && !this.currentUser.id;
    },

    loadMore: function () {
      if (this.busy || this.searchParams.page === this.propertiesData.pagination.totalPages || this.isMaxedOffMarket())
        return;

      this.busy = true;
      this.goToPage(this.searchParams.page + 1);
    },

    markerPrice(price) {
      let format = price > 1000000 ? "$ 0.00a" : "$ 0a";
      return this.$options.filters.numeralFormat(price, format);
    },

    cycle() {
      const self = this,
        isochroneParams = self.currentUser.isochroneParams;

      isochrone.compute({
        lat: isochroneParams.lat,
        lng: isochroneParams.lng,
        cycles: 2,
        slices: 10,
        type: "duration", // distance || duration
        value: parseFloat(isochroneParams.value), // 1 hour
        mode: isochroneParams.mode, // (walking|bicycling|driving|transit)
        callback: function(status, points) {
          self.polygonPaths = points.map(p => {
            return { lat: p.lat, lng: p.lng };
          });
        }
      });
    },

    collectMarkers() {
      if (this.propertiesData.clusteredEntities != null) {
        this.isClusters = true;
        this.markers = this.propertiesData.clusteredEntities;
      } else {
        if (
          this.propertiesData.pinEntities &&
          this.propertiesData.pinEntities.length
        ) {
          this.isClusters = false;

          this.markers = this.propertiesData.pinEntities.map((prop, index) => {
            let icon = {
              icon: this.markerIcon(prop)
            };

            return { ...prop, ...icon, zIndex: 100 + index };
          });

          this.circles = this.propertiesData.pinEntities.filter(
            p => p.onMarket == false
          );
        } else {
          this.markers = [];
        }
      }
    },

    clusterIcon(counter) {
      let size = {};

      switch (true) {
        case counter < 10:
          size = { width: 32, height: 32 };
          break;

        case counter >= 10 && counter < 25:
          size = { width: 36, height: 36 };
          break;

        case counter >= 26 && counter < 75:
          size = { width: 40, height: 40 };
          break;

        case counter >= 76 && counter < 150:
          size = { width: 44, height: 44 };
          break;

        case counter >= 150 && counter < 250:
          size = { width: 48, height: 48 };
          break;

        case counter >= 250:
          size = { width: 52, height: 52 };
          break;

        default:
          size = { width: 32, height: 32 };
          break;
      }

      return {
        url: require("@/assets/images/icons/black.svg"),
        scaledSize: size
      };
    },

    markerIcon(m, scaled = false) {
      return {
        url: require(`@/assets/images/icons/pin_${
          m.onMarket ? "onMarket" : "offMarket"
        }.svg`),

        anchor: m.onMarket
          ? null
          : { x: scaled ? 27 : 24, y: scaled ? 22 : 20 },
        scaledSize: scaled
          ? { width: 54, height: 30 }
          : { width: 48, height: 27 }
      };
    },

    handleHihglightProperty(markerId, type) {
      if (this.isClusters) {
        if (type) {
          let activeProperty = this.propertiesData.entities.find(
            p => p.id === markerId
          );

          let pin = {
            ...activeProperty,
            position: {
              lat: activeProperty.coordinates[0],
              lng: activeProperty.coordinates[1]
            },
            zIndex: 1000,
            icon: this.markerIcon(activeProperty)
          };

          this.pins.push(pin);
        } else {
          this.pins.pop();
        }
      } else {
        let activeMarker = this.markers.find(m => m.id === markerId);

        let activeProperty = this.propertiesData.entities.find(
          p => p.id === markerId
        );

        if (activeProperty) {
          activeProperty.isHighlighted = type;
        }

        activeMarker.icon = this.markerIcon(activeMarker, type);
        activeMarker.zIndex = type
          ? 1000
          : 100 + Math.floor(Math.random() * 20) + 1;
      }
    },

    toggleInfoWindow(marker, idx) {
      this.infoWindowPos = marker.position;

      this.infoOptions = marker;

      if (this.currentMidx == idx) {
        this.infoWinOpen = !this.infoWinOpen;
      } else {
        this.infoWinOpen = true;
        this.currentMidx = idx;
      }
    },

    expandMarker(marker) {
      this.updateProperties(marker);
    },

    goToPage(current) {
      this.searchParams.page = current;

      this.searchParams.skipUpdateMap = true;

      this.triggerPropertiesQuery(false);
    },

    handleBoostChange() {
      this.$router.push({name: "home"});
    },

    boundsChanged: debounce(function(event) {
      if (event != undefined && this.listenChanges) {
        var bounds = this.$refs.gmap.$mapObject.getBounds();
        this.currentBounds = {
          latitudes: [bounds.getNorthEast().lat(), bounds.getSouthWest().lat()],
          longitudes: [bounds.getNorthEast().lng(), bounds.getSouthWest().lng()]
        };

        if (!this.isShowUpdateMapBtn) {
          this.isShowUpdateMapBtn = true;
        }
      }
    }, 300),

    updateSearchByBounds() {
      this.infoWinOpen = false;
      this.isUpdateByNewViewPort = true;
      this.updateProperties(this.currentBounds);
    },

    updateProperties(data) {
      this.searchParams.mapFilters = {
        cluster: data.cluster ? data.cluster : null,
        latitudes: data.latitudes ? data.latitudes : [],
        longitudes: data.longitudes ? data.longitudes : []
      };

      if (this.isUpdateByNewViewPort) {
        this.searchParams.address.placeId = "";
      }

      this.searchParams.page = 1;
      this.searchParams.skipUpdateMap = false;

      this.triggerPropertiesQuery(true);
    },

    handleUpdatePropertyInteresting(data) {
      let entity = this.properties.entities.find(p => p.id == data.id);

      if (entity) {
        entity.isInteresting = data.interesting;
      }

      let marker = this.markers.find(p => p.id == data.id);

      if (marker) {
        marker.isInteresting = data.interesting;
      }

      if (this.infoOptions.isInteresting != undefined) {
        this.infoOptions.isInteresting = data.interesting;
      }
    },

    handleChangeSorting(type) {
      if (type == "newest") {
        this.searchParams.sort = "newest";
        this.searchParams.sortOrder = "";
      } else {
        this.searchParams.sort = "price";
        this.searchParams.sortOrder = type;
      }

      this.triggerPropertiesQuery(true);
    },

    handleChangeStatus(type) {
      if (this.isShowModal)
        this.isShowModal = false;
      this.searchParams.marketStatus = type;
      this.goToPage(1);
      this.triggerPropertiesQuery(true);
    },

    triggerPropertiesQuery(isLoading) {
      this.isPropertiesLoading = isLoading;
      this.searchParams.skipUpdateMap = false;
      this.skipPropertiesQuery = false;
    }
  },

  components: {
    EmptySearch,
    NonRegistered,
    Property,
    MapIcon,
    LoadingIcon,
    PromoSignUp,
    Pagination,
    Filters,
    SortBy,
    Questionary,
    Tabs
  }
};
